import Forgotpassword from "../page/Login/Forgotpassword";
import Resetpassword from "../page/Login/Resetpassword";
// import Login from "../page/Login/Login";
import Login from "../page/Login/Diwalilogin";
import MainDivision from "../Component/Company/MainCompany";
import EmployeeDeatilsDashboard from "../page/EmployeeDashboard";
import Mainproject from "../Component/Project/Mainproject";
import ConsultantManagement from "../Component/Consultantmangement/ConsultantManagement";
import ProjectPageForHOD from "../Component/Project/ProjectPageForHOD";
import HighwayPage from "../Component/Project/highways/Highwaypage";
import RailwayPage from "../Component/Project/railways/RailwayPage";
import { ProjectAllDetails } from "../Component/Project/ProjectDetails";
import DPRAuditLogPage from "../Component/DPRAuditLog";
import LettersRegister from "../Component/Project/Letters/LettersRegister";
import LetterDetail from "../Component/Project/Letters/LetterDetail";
import RopewayPage from "../Component/Project/ropeways/RopewayPage";

const ALL   = ["super_admin", "admin", "hod", "engineer", "viewer"];
const EDIT  = ["super_admin", "admin", "hod", "engineer"];
const MGMT  = ["super_admin", "admin"];
const ADMIN = ["super_admin"];

export const routingData = [
  {
    role        : "",
    isProtected : false,
    defaultRoute: "/",
    routes: [
      { path: "",                              component: <Login /> },
      { path: "login",                         component: <Login /> },
      { path: "forgotpassword/",               component: <Forgotpassword /> },
      { path: "resetpassword/:uidb64/:token/", component: <Resetpassword /> },
    ],
  },
  {
    role        : "super_admin",
    allowedRoles: ALL,
    isProtected : true,
    defaultRoute: "super_admin/projectportfolio/",
    nestedRoutes: [
      {
        path     : "super_admin",
        component: <EmployeeDeatilsDashboard />,
        routes   : [
          { path: "projectportfolio",  component: <ProjectPageForHOD />,   allowedRoles: ALL   },
          { path: "projectmanagement", component: <Mainproject />,          allowedRoles: MGMT  },
          { path: "companymanagement", component: <MainDivision />,         allowedRoles: ADMIN },
          { path: "highwayprojects",   component: <HighwayPage />,          allowedRoles: EDIT  },
          { path: "railwaysprojects",  component: <RailwayPage />,          allowedRoles: EDIT  },
          { path: "ropewayprojects",   component: <RopewayPage />,          allowedRoles: EDIT  },
          { path: "settings",          component: <ConsultantManagement />, allowedRoles: MGMT  },
          { path: "ProjectAllDetails", component: <ProjectAllDetails />,    allowedRoles: EDIT  },
          { path: "auditlog",          component: <DPRAuditLogPage />,      allowedRoles: ADMIN },
          { path: "letters",           component: <LettersRegister />,     allowedRoles: ALL   },
          { path: "letters/:id",       component: <LetterDetail />,        allowedRoles: ALL   },
        ],
      },
    ],
  },
  {
    role        : "admin",
    allowedRoles: ALL,
    isProtected : true,
    defaultRoute: "admin/projectportfolio/",
    nestedRoutes: [
      {
        path     : "admin",
        component: <EmployeeDeatilsDashboard />,
        routes   : [
          { path: "projectportfolio",  component: <ProjectPageForHOD />,   allowedRoles: ALL  },
          { path: "projectmanagement", component: <Mainproject />,          allowedRoles: MGMT },
          { path: "highwayprojects",   component: <HighwayPage />,          allowedRoles: EDIT },
          { path: "railwaysprojects",  component: <RailwayPage />,          allowedRoles: EDIT },
          { path: "settings",          component: <ConsultantManagement />, allowedRoles: MGMT },
          { path: "ProjectAllDetails", component: <ProjectAllDetails />,    allowedRoles: EDIT },
          { path: "letters",           component: <LettersRegister />,     allowedRoles: ALL  },
          { path: "letters/:id",       component: <LetterDetail />,        allowedRoles: ALL  },
        ],
      },
    ],
  },
  {
    role        : "hod",
    allowedRoles: ALL,
    isProtected : true,
    defaultRoute: "hod/projectportfolio/",
    nestedRoutes: [
      {
        path     : "hod",
        component: <EmployeeDeatilsDashboard />,
        routes   : [
          { path: "projectportfolio",  component: <ProjectPageForHOD />, allowedRoles: ALL  },
          { path: "highwayprojects",   component: <HighwayPage />,       allowedRoles: EDIT },
          { path: "railwaysprojects",  component: <RailwayPage />,       allowedRoles: EDIT },
          { path: "ProjectAllDetails", component: <ProjectAllDetails />, allowedRoles: EDIT },
          { path: "letters",           component: <LettersRegister />,  allowedRoles: ALL  },
          { path: "letters/:id",       component: <LetterDetail />,     allowedRoles: ALL  },
        ],
      },
    ],
  },
  {
    role        : "engineer",
    allowedRoles: ALL,
    isProtected : true,
    defaultRoute: "ed/projectportfolio/",
    nestedRoutes: [
      {
        path     : "ed",
        component: <EmployeeDeatilsDashboard />,
        routes   : [
          { path: "projectportfolio",  component: <ProjectPageForHOD />, allowedRoles: ALL  },
          { path: "highwayprojects",   component: <HighwayPage />,       allowedRoles: EDIT },
          { path: "railwaysprojects",  component: <RailwayPage />,       allowedRoles: EDIT },
          { path: "ProjectAllDetails", component: <ProjectAllDetails />, allowedRoles: EDIT },
          { path: "letters",           component: <LettersRegister />,  allowedRoles: ALL  },
          { path: "letters/:id",       component: <LetterDetail />,     allowedRoles: ALL  },
        ],
      },
    ],
  },
  {
    role        : "viewer",
    allowedRoles: ALL,
    isProtected : true,
    defaultRoute: "viewer/projectportfolio/",
    nestedRoutes: [
      {
        path     : "viewer",
        component: <EmployeeDeatilsDashboard />,
        routes   : [
          { path: "projectportfolio", component: <ProjectPageForHOD />, allowedRoles: ALL },
          { path: "letters",          component: <LettersRegister />,  allowedRoles: ALL },
          { path: "letters/:id",      component: <LetterDetail />,     allowedRoles: ALL },
        ],
      },
    ],
  },
];